/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Pick_StepInputs */

const en_session_pick_step = /** @type {(inputs: Session_Pick_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step 1 of 2 · Pick a recipe`)
};

const de_session_pick_step = /** @type {(inputs: Session_Pick_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt 1 von 2 · Rezept wählen`)
};

/**
* | output |
* | --- |
* | "Step 1 of 2 · Pick a recipe" |
*
* @param {Session_Pick_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_pick_step = /** @type {((inputs?: Session_Pick_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Pick_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_pick_step(inputs)
	return en_session_pick_step(inputs)
});